<template>
  <div>
    <div
      class="border-b border-yellow-300 bg-yellow-50 p-3 text-center text-sm text-yellow-800"
    >
      This application is read-only ahead of its decommissioning. You can still
      view your information, but no longer change it.
    </div>
    <Loader v-if="loading || isAuthLoading" />
    <Callback v-else-if="isCallbackRoute" />
    <Claims v-else-if="isClaimRoute" />
    <Telematics v-else-if="isTelematicsRoute" />
    <VerifyAccount v-else-if="user != null && !user.emailVerified" />
    <PendingAccount
      v-else-if="$store.state.account?.status === 'Pending Activation'"
    />
    <MissingAccount v-else-if="user != null && $store.state.account == null" />
    <Redirecting v-else-if="user != null && !isCallbackRoute" />
  </div>
</template>

<script>
import Claims from "@/Claims.vue";
import Callback from "@/Callback.vue";
import MissingAccount from "@/MissingAccount.vue";
import PendingAccount from "@/PendingAccount.vue";
import VerifyAccount from "@/VerifyAccount.vue";
import Telematics from "@/Telematics.vue";
import Loader from "@/Loader.vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { watch, ref, defineComponent } from "vue";
import { useStore } from "vuex";

const Redirecting = defineComponent({
  template: `<div class="flex items-center justify-center min-h-screen bg-gray-100">
    <div class="text-center p-8 bg-white rounded-lg shadow-md">
      <p class="text-gray-600">Redirecting...</p>
    </div>
  </div>`,
  mounted() {
    const redirectUrl = process.env["VUE_APP_PORTAL_REDIRECT_URL"] || "https://getaddify.app";
    window.location.replace(redirectUrl);
  },
});

export default {
  components: {
    Callback,
    Claims,
    Loader,
    MissingAccount,
    PendingAccount,
    Redirecting,
    Telematics,
    VerifyAccount,
  },
  setup() {
    const { isLoading } = useAuth0();
    const store = useStore();

    // Normal auth flow - wait for Auth0 to finish loading
    watch([isLoading], () => {
      if (isLoading.value) return;
      store.dispatch("initialLoad");
    });

    if (!isLoading.value) {
      store.dispatch("initialLoad");
    }

    return {
      isAuthLoading: isLoading,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isClaimRoute() {
      return window.location.pathname.includes("/claims");
    },
    isTelematicsRoute() {
      return window.location.pathname.includes("/telematics");
    },
    isCallbackRoute() {
      return window.location.pathname === "/redirect";
    },
    loading() {
      return this.$store.state.loading;
    },
  },
};
</script>
